import React from 'react';
import { Button } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import * as yup from 'yup';

import { createYupSchema, getMeasureInputField } from '../../shared/inputs/inputHelpers';
import TextField from '../../shared/inputs/formik/TextField';

function MeasureDataEntryForm({ data, isClientMeasure, onSubmit }) {
  const { fields } = data;
  const showClientLookup = isClientMeasure || false;

  const scoreDateFieldName = "scoreDate";
  const firstNameFieldName = "firstName";
  const lastNameFieldName = "lastName";
  const dobFieldName = "dateOfBirth";

  const today = new Date().toISOString().split('T')[0];
  let initialValues = { ...data, [scoreDateFieldName]: today };

  fields.forEach(field => {
    initialValues[field.name] = field.defaultValue !== null ? field.defaultValue : '';
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form className="my-3">

          {showClientLookup ?
            <React.Fragment>

              <TextField
                name={firstNameFieldName}
                label="First Name"
                required={true}

                value={values && values[firstNameFieldName]}
                error={errors[firstNameFieldName]}
                touched={touched[firstNameFieldName]}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={errors[firstNameFieldName]}
                isInvalid={touched[firstNameFieldName] && !!errors[firstNameFieldName]}
              />

              <TextField
                name={lastNameFieldName}
                label="Last Name"
                required={true}

                value={values && values[lastNameFieldName]}
                error={errors[lastNameFieldName]}
                touched={touched[lastNameFieldName]}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={errors[lastNameFieldName]}
                isInvalid={touched[lastNameFieldName] && !!errors[lastNameFieldName]}
              />

              <TextField
                name={dobFieldName}
                label="Date of Birth"
                type="date"
                as="date"
                required={true}

                value={values && values[dobFieldName]}
                error={errors[dobFieldName]}
                touched={touched[dobFieldName]}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={errors[dobFieldName]}
                isInvalid={touched[dobFieldName] && !!errors[dobFieldName]}
              />

            </React.Fragment> :
            <></>}
          <TextField
            name={scoreDateFieldName}
            label="Measure Date"
            type="date"
            as="date"
            required={true}

            value={values && values[scoreDateFieldName]}
            error={errors[scoreDateFieldName]}
            touched={touched[scoreDateFieldName]}
            onChange={handleChange}
            onBlur={handleBlur}
            errorMessage={errors[scoreDateFieldName]}
            isInvalid={touched[scoreDateFieldName] && !!errors[scoreDateFieldName]}
          />

          {values?.fields.map((field) => {

            return getMeasureInputField(field,
              {
                value: values && values[field.name],
                error: errors[field.name],
                touched: touched[field.name],
                onChange: handleChange,
                onBlur: handleBlur,
                errorMessage: errors[field.name],
                isInvalid: touched[field.name] && !!errors[field.name]
              })
          })}

          <Button type="submit" variant="primary">Submit</Button>
        </Form>
      )}
    </Formik>
  );
}

export default MeasureDataEntryForm;
